<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4" align="center" justify="center">
        <v-card elevation="2" :loading="loading" class="my-2">
          <v-card-title>Subscription</v-card-title>
          <v-card-text>
            <v-simple-table v-if="subscription">
              <tbody align="center">
                <tr>
                  <td>Client</td>
                  <td>
                    {{
                      subscription.user.firstName +
                      " " +
                      subscription.user.lastName
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Product</td>
                  <td>{{ subscription.product.name }}</td>
                </tr>
                <tr>
                  <td>Sign Up Date</td>
                  <td>{{ formatDate(subscription.startDate) }}</td>
                </tr>
                <tr>
                  <td>Program Start Date</td>
                  <td>
                    <span v-if="!edit">
                      {{
                        subscription.programStartDate != null &&
                        formatDate(subscription.programStartDate)
                      }}
                    </span>
                    <span v-else>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <h4>
                            Please only update this when client is being
                            onboarded
                          </h4>
                          <v-text-field
                            v-model="form.programStartDate"
                            label="Program start date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="form.programStartDate"
                          @input="menu2 = false"
                          :allowed-dates="allowedDates"
                        ></v-date-picker>
                      </v-menu>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Coach</td>
                  <td>
                    <span v-if="!edit"> {{ getName(subscription.coach) }}</span>
                    <v-autocomplete
                      v-if="edit"
                      v-model="form.coachId"
                      dense
                      :items="staff"
                    ></v-autocomplete>
                  </td>
                </tr>
                <tr>
                  <td>Connect Owner</td>
                  <td>
                    <span v-if="!edit">
                      {{ getName(subscription.connectOwner) }}</span
                    >
                    <v-autocomplete
                      v-if="edit"
                      v-model="form.connectOwnerId"
                      dense
                      :items="staff"
                    ></v-autocomplete>
                  </td>
                </tr>
                <tr>
                  <td>Support Owner</td>
                  <td>
                    <span v-if="!edit">
                      {{ getName(subscription.supportOwner) }}</span
                    >

                    <v-autocomplete
                      v-if="edit"
                      v-model="form.supportOwnerId"
                      dense
                      :items="staff"
                    ></v-autocomplete>
                  </td>
                </tr>
                <tr>
                  <td>Stage</td>
                  <td>{{ subscription.stage }}</td>
                </tr>
                <tr>
                  <td>Active</td>
                  <td>
                    <v-icon
                      v-if="subscription.active"
                      color="success"
                      style="display: block"
                      >check_circle</v-icon
                    >
                    <v-icon v-else color="error">cancel</v-icon>
                  </td>
                </tr>
                <tr>
                  <td>Service start date</td>
                  <td>
                    <span v-if="subscription.serviceStartDate">
                      {{ formatDate(subscription.serviceStartDate) }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td>
                    <span v-if="subscription.endDate">
                      {{ formatDate(subscription.endDate) }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="edit" @click="cancel()" :loading="saving"
              >Cancel</v-btn
            >
            <v-spacer />
            <v-btn v-if="edit" :loading="saving" @click="updateSubscription()"
              >Save</v-btn
            >
            <v-btn v-if="!edit" @click="edit = true">Edit</v-btn>
          </v-card-actions>
        </v-card>
        <v-card
          v-if="subscription && subscription.billingOrder"
          elevation="2"
          :loading="loading"
          class="my-2"
        >
          <v-card-title>Billing order</v-card-title>
          <div>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>Order Status:</td>
                  <td>{{ subscription.billingOrder.orderStatus }}</td>
                </tr>
                <tr>
                  <td>Paid up until: <small>Payments due after the 28th are billed on the 28th</small></td>
                  <td>{{ subscription.billingOrder.nextBillingDate }}</td>
                </tr>
                <tr>
                  <td>Transaction Method:</td>
                  <td>{{ subscription.billingOrder.transactionMethod }}</td>
                </tr>
                <tr>
                  <td>Payment Method:</td>
                  <td>{{ subscription.billingOrder.paymentMethod }}</td>
                </tr>
                <tr>
                  <td>Currency:</td>
                  <td>{{ subscription.billingOrder.currency }}</td>
                </tr>
                <tr>
                  <td>Discount Amount:</td>
                  <td>{{ subscription.billingOrder.discountAmount }}</td>
                </tr>
                <tr>
                  <td>Billing Start Date:</td>
                  <td>{{ subscription.billingOrder.billingStartDate }}</td>
                </tr>
                <tr>
                  <td>Billing Period:</td>
                  <td>{{ subscription.billingOrder.billingPeriod }}</td>
                </tr>
                <tr>
                  <td>Cancellation Date:</td>
                  <td>{{ subscription.billingOrder.cancellationDate }}</td>
                </tr>
                <tr>
                  <td>Suspension Date:</td>
                  <td>{{ subscription.billingOrder.suspensionDate }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card>
        <v-btn
          v-if="
            subscription &&
            (!subscription.endDate || $moment() < $moment(subscription.endDate))
          "
          @click="modal.showCancelForm = true"
          >Process cancellation request</v-btn
        >
        <v-card elevation="2" :loading="loading" class="my-2">
          <v-card-title>Onboarding Checks</v-card-title>
          <div>
            <v-simple-table v-if="subscription">
              <thead>
                <tr>
                  <th class="text-left">Check</th>
                  <th class="text-left">User</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="check in subscription.subscriptionProcessChecks"
                  :key="check.id"
                >
                  <td>{{ check.type }}</td>
                  <td>{{ getName(check.user) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="subscription" cols="8" align="center" justify="center">
        <v-card elevation="2" :loading="loading" class="my-2">
          <v-card-title>Program History</v-card-title>
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">Program Start Date</th>
                <th class="text-left">Program</th>
                <th class="text-left">Nutrition Plan</th>
                <th class="text-left">Coach</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="userProgram in subscription.userPrograms"
                :key="userProgram.id"
              >
                <td>{{ formatDate(userProgram.programStartDate) }}</td>
                <td>{{ userProgram.program.name }}</td>
                <td>
                  {{
                    userProgram.nutritionPlan && userProgram.nutritionPlan.name
                  }}
                </td>
                <td>{{ getName(userProgram.coach) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
        <v-card
          v-if="subscription.billingOrder"
          elevation="2"
          :loading="loading"
          class="my-2"
        >
          <v-card-title>Discounts</v-card-title>
          <div>
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left">Created by</th>
                  <th class="text-left">Is Promotion</th>
                  <th class="text-left">Max Uses</th>
                  <th class="text-left">StartDate</th>
                  <th class="text-left">End Date</th>
                  <th class="text-left">newUsersOnly</th>
                  <th class="text-left">restrictedToUser</th>
                  <th class="text-left">flatDiscount</th>
                  <th class="text-left">percentageDiscount</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="discount in subscription.billingOrder.discounts.edges"
                  :key="discount.node.id"
                >
                  <td>{{ discount.node.title }}</td>
                  <td>
                    {{
                      discount.node.createdByUser &&
                      discount.node.createdByUser.firstName
                    }}
                  </td>
                  <td>{{ discount.node.isPromotion }}</td>
                  <td>{{ discount.node.maxUses }}</td>
                  <td>{{ discount.node.numberOfUses }}</td>
                  <td>{{ discount.node.startDate }}</td>
                  <td>{{ discount.node.endDate }}</td>
                  <td>{{ discount.node.newUsersOnly }}</td>
                  <td>
                    {{
                      discount.node.restrictedToUser &&
                      discount.node.restrictedToUser.email
                    }}
                  </td>
                  <td>{{ discount.node.flatDiscount }}</td>
                  <td>{{ discount.node.percentageDiscount }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card>
        <v-card
          v-if="subscription.billingOrder"
          elevation="2"
          :loading="loading"
        >
          <v-card-title>Peach Payments</v-card-title>
          <div>
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Billing Date</th>
                  <th class="text-left">Payment Status</th>
                  <th class="text-left">Retries</th>
                  <th class="text-left">Total Amount</th>
                  <th class="text-left">Discount Amount</th>
                  <th class="text-left">Billing country</th>
                  <th class="text-left">Transactions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="payment in subscription.billingOrder.payments"
                  :key="payment.id"
                >
                  <td>{{ payment.billingDate }}</td>
                  <td>{{ payment.paymentStatus }}</td>
                  <td>{{ payment.retries }}</td>
                  <td>{{ payment.totalAmount }}</td>
                  <td>{{ payment.discountAmount }}</td>
                  <td>{{ payment.country }}</td>
                  <td>
                    <span
                      v-for="transaction in payment.transactionSet"
                      :key="transaction.id"
                    >
                      {{ transaction.transactionStatus }} with code:
                      {{ transaction.gatewayResponse }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card>
        <v-card v-else elevation="2" :loading="loading">
          <v-card-title>Shopify Orders</v-card-title>
          <div>
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Order</th>
                  <th class="text-left">Order date</th>
                  <th class="text-left">shopifyCustomerId</th>
                  <th class="text-left">shopifyOrderId</th>
                  <th class="text-left">totalPrice</th>
                  <th class="text-left">sku</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="order in subscription.orders" :key="order.id">
                  <td>{{ order.number }}</td>
                  <td>{{ formatDate(order.closedAt) }}</td>
                  <td>{{ order.shopifyCustomerId }}</td>
                  <td>{{ order.shopifyOrderId }}</td>
                  <td>{{ order.totalPrice }}</td>
                  <td>{{ order.sku }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="modal.showCancelForm"
      width="600"
      transition="dialog-bottom-transition"
    >
      <end-subscription :subscriptionId="subscriptionId"></end-subscription>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  SUBSCRIPTION_QUERY,
  UPDATE_SUBSCRIPTION_MUTATION,
} from "@/constants/graphql/users/subscription";
import { STAFF_QUERY } from "@/constants/graphql/users/user";
import { YYYYMMDD_readable } from "@/lib/fancy_date";
import { getUserName } from "@/lib/username";
import EndSubscription from "@/components/operations/EndSubscription";

export default {
  name: "ManageSubscription",
  props: ["subscriptionId"],
  components: {
    EndSubscription,
  },
  data() {
    return {
      loading: true,
      saving: false,
      subscription: null,
      staff: [],
      edit: false,
      menu: false,
      menu2: false,
      modal: {
        showCancelForm: false,
      },
      form: {
        requiredDate: null,
        requiredTime: null,
        connectOwnerId: null,
        coachId: null,
        supportOwnerId: null,
        programStartDate: null,
      },
      allowedDates: (val) => new Date(val).getUTCDay() === 1,
    };
  },
  methods: {
    getName(user) {
      return getUserName(user);
    },
    formatDate(date) {
      return YYYYMMDD_readable(date);
    },
    getId(base64string) {
      let decoded = atob(base64string).split(":");
      if (decoded[1]) return decoded[1];
      return "";
    },
    cancel() {
      this.form.connectOwnerId = this.subscription?.connectOwner?.id;
      this.form.supportOwnerId = this.subscription?.supportOwner?.id;
      this.form.coachId = this.subscription.coach
        ? this.subscription.coach.id
        : null;
      this.form.coachId = this.subscription.programStartDate;
      if (this.subscription.endDate) {
        this.form.requiredDate = this.$moment(this.subscription.endDate).format(
          "YYYY-MM-DD"
        );
        this.form.requiredTime = this.$moment(this.subscription.endDate).format(
          "hh:mm"
        );
      } else {
        this.form.requiredDate = null;
        this.form.requiredTime = null;
      }
      this.edit = false;
    },
    removeEndDate() {
      this.form.requiredDate = null;
      this.form.requiredTime = null;
    },
    updateSubscription() {
      this.saving = true;
      let input = { id: this.subscription.id };

      if (this.form.programStartDate) {
        input["programStartDate"] = this.form.programStartDate;
      }

      if (this.form.requiredDate && this.form.requiredTime) {
        input["endDate"] = new Date(
          this.form.requiredDate + " " + this.form.requiredTime
        );
      }

      if (this.form.connectOwnerId) {
        input["connectUserId"] = this.form.connectOwnerId;
      }

      if (this.form.coachId) {
        input["supportUserId"] = this.form.supportOwnerId;
      }

      if (this.form.coachId) {
        input["coachUserId"] = this.form.coachId;
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_SUBSCRIPTION_MUTATION,
          variables: {
            input: input,
          },
          refetchQueries: ["subscriptionQuery"],
        })
        .then((result) => {
          if (!result.data.updateSubscriptionRecord.updated) {
            alert(result.data.updateSubscriptionRecord.error);
          } else {
            this.$toasted.success("Subscription has been updated", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
          this.saving = false;
          this.edit = false;
        })
        .catch((error) => {
          this.saving = false;
        });
    },
  },
  apollo: {
    subscription: {
      query: SUBSCRIPTION_QUERY,
      variables() {
        return {
          id: this.subscriptionId,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.subscriptionById;
      },
      result(response) {
        if (response.data) {
          this.loading = false;
          let subscription = response.data.subscriptionById;
          this.form.connectOwnerId = subscription?.connectOwner?.id;
          this.form.supportOwnerId = subscription?.supportOwner?.id;
          this.form.coachId = subscription?.coach?.id;
          this.form.programStartDate = subscription.programStartDate;
          if (subscription.endDate) {
            this.form.requiredDate = this.$moment(subscription.endDate).format(
              "YYYY-MM-DD"
            );
            this.form.requiredTime = this.$moment(subscription.endDate).format(
              "hh:mm"
            );
          }
        }
      },
    },
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.staff = [];

          response.data.users.edges.forEach((item) => {
            let data = {
              value: this.getId(item.node.id),
              text: getUserName(item.node),
            };

            this.staff.push(data);
          });
        }
        if (
          response.error &&
          response.error.gqlError?.message == "Permission Denied."
        ) {
          this.$router.push("/no-access");
        }
      },
    },
  },
};
</script>
